<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'計測方法の確認／切替え'">
          <list-item :spanText="'Q. '" :text="'歩数計測しているデバイスを確認する方法'" :urlName="'Help28'"></list-item>
          <list-item :spanText="'Q. '" :text="'ﾍﾙｽｹｱに切替えたら歩数がｶｳﾝﾄされなくなった'" :urlName="'Help39'"></list-item>
          <list-item :spanText="'Q. '" :text="'ﾍﾙｽｹｱに切替えたら歩数がﾍﾙｽｹｱｱﾌﾟﾘより少ない'" :urlName="'Help41'"></list-item>
          <list-item :spanText="'Q. '" :text="'ｽﾏﾎで計測した歩数はﾍﾙｽｹｱｱﾌﾟﾘと異なる日がある'" :urlName="'Help40'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory13.vue